import type { BookSetting, Common } from '@libs/domain';
import type { IncreDecreBookValSet } from '@libs/enums';
import { increDecreBookValSet } from '@libs/enums';
import type { OrEmpty } from '@ps-smart-cp/ppfw-client';

export class Book
  implements
    Pick<BookSetting['schema'], 'bookName' | 'ifrsBook' | 'increDecreBookValSet' | 'key'>,
    Pick<Common['schema'], 'isUsed'>
{
  public static readonly BOOK_ID_INITIAL_VALUE = '1';

  private constructor(
    readonly key: number,
    readonly bookName: string,
    readonly isUsed: boolean,
    readonly ifrsBook: boolean,
    readonly increDecreBookValSet: OrEmpty<IncreDecreBookValSet>,
  ) {}

  static init() {
    return new Book(1, '', false, false, '');
  }

  static fromRaw(raw: BookRaw) {
    return new Book(
      raw.key,
      raw.bookName,
      raw.isUsed,
      raw.ifrsBook,
      increDecreBookValSet.toEnum(raw.increDecreBookValSet),
    );
  }

  static fromRaws(raws: BookRaw[]) {
    return raws.map(Book.fromRaw);
  }
}

export interface BookRaw {
  readonly key: number;
  readonly bookName: string;
  readonly isUsed: boolean;
  readonly ifrsBook: boolean;
  readonly increDecreBookValSet: string;
}
